// Contains utility functions intended to be used to pick files

export type FileOptions = {
  accept?: Array<string>;
  capture?: 'user' | 'environment' | 'implementation' | 'none';
  selectionMode?: 'single' | 'multiple';
};

export function pickFiles(
  callback: (files: FileList) => void,
  { accept = [], capture = 'none', selectionMode = 'single' }: FileOptions
) {
  const input = createInput({ accept, capture, selectionMode }) as any;

  input.addEventListener(
    'change',
    () => {
      // If this is a webdriver test, _pickerTestData will be populated and should use it
      const files = input._pickerTestData ? input._pickerTestData : input.files;
      callback(files as FileList);
    },
    { once: true }
  );

  input.click();
}

const createInput = (fileOptions: Required<FileOptions>) => {
  const input = document.createElement('input');
  input.type = 'file';
  if (fileOptions?.capture && fileOptions.capture != 'none') {
    input.capture = fileOptions.capture;
  }
  input.accept = fileOptions.accept.join(',');
  input.multiple = fileOptions.selectionMode === 'multiple';
  input.style.display = 'none';
  return input;
};
